/**
 * @fileoverview gRPC-Web generated client stub for tprmquestionnaire
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: tprmquestionnaire/tprmquestionnaire.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_annotations_pb = require('../authz/annotations_pb.js')

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js')

var common_due_date_reminder_pb = require('../common/due_date_reminder_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.tprmquestionnaire = require('./tprmquestionnaire_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listQuestionnaireTemplates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listQuestionnaireTemplates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetQuestionnaireFormRequest,
 *   !proto.tprmquestionnaire.QuestionnaireForm>}
 */
const methodDescriptor_QuestionnaireService_GetQuestionnaireForm = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetQuestionnaireFormRequest,
  proto.tprmquestionnaire.QuestionnaireForm,
  /**
   * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireForm.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getQuestionnaireForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireForm>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getQuestionnaireForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ExportFormCsvRequest,
 *   !proto.tprmquestionnaire.ExportFormCsvResponse>}
 */
const methodDescriptor_QuestionnaireService_ExportFormCsv = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ExportFormCsvRequest,
  proto.tprmquestionnaire.ExportFormCsvResponse,
  /**
   * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ExportFormCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ExportFormCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.exportFormCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ExportFormCsvResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.exportFormCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest,
 *   !proto.tprmquestionnaire.QuestionnaireTemplate>}
 */
const methodDescriptor_QuestionnaireService_CreateQuestionnaireTemplate = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/CreateQuestionnaireTemplate',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest,
  proto.tprmquestionnaire.QuestionnaireTemplate,
  /**
   * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.createQuestionnaireTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateQuestionnaireTemplate,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireTemplate>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.createQuestionnaireTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateQuestionnaireTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest,
 *   !proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse>}
 */
const methodDescriptor_QuestionnaireService_GetQuestionnaireTemplateDetail = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireTemplateDetail',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest,
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getQuestionnaireTemplateDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireTemplateDetail',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireTemplateDetail,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getQuestionnaireTemplateDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireTemplateDetail',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireTemplateDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest,
 *   !proto.tprmquestionnaire.QuestionnaireTemplate>}
 */
const methodDescriptor_QuestionnaireService_UpdateQuestionnaireTemplateMeta = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/UpdateQuestionnaireTemplateMeta',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest,
  proto.tprmquestionnaire.QuestionnaireTemplate,
  /**
   * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.updateQuestionnaireTemplateMeta =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateQuestionnaireTemplateMeta',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateQuestionnaireTemplateMeta,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireTemplate>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.updateQuestionnaireTemplateMeta =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateQuestionnaireTemplateMeta',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateQuestionnaireTemplateMeta);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest,
 *   !proto.tprmquestionnaire.QuestionnaireTemplate>}
 */
const methodDescriptor_QuestionnaireService_DuplicateQuestionnaireTemplate = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/DuplicateQuestionnaireTemplate',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest,
  proto.tprmquestionnaire.QuestionnaireTemplate,
  /**
   * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.duplicateQuestionnaireTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DuplicateQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DuplicateQuestionnaireTemplate,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireTemplate>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.duplicateQuestionnaireTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DuplicateQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DuplicateQuestionnaireTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_QuestionnaireService_DeleteQuestionnaireTemplate = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireTemplate',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.deleteQuestionnaireTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireTemplate,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.deleteQuestionnaireTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireTemplate',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest,
 *   !proto.tprmquestionnaire.FormSection>}
 */
const methodDescriptor_QuestionnaireService_SaveQuestionnaireFormSection = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormSection',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest,
  proto.tprmquestionnaire.FormSection,
  /**
   * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.FormSection.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.FormSection)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.FormSection>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.saveQuestionnaireFormSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormSection',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SaveQuestionnaireFormSection,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.FormSection>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.saveQuestionnaireFormSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormSection',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SaveQuestionnaireFormSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest,
 *   !proto.tprmquestionnaire.FormQuestion>}
 */
const methodDescriptor_QuestionnaireService_SaveQuestionnaireFormQuestion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormQuestion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest,
  proto.tprmquestionnaire.FormQuestion,
  /**
   * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.FormQuestion.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.FormQuestion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.FormQuestion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.saveQuestionnaireFormQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SaveQuestionnaireFormQuestion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.FormQuestion>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.saveQuestionnaireFormQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SaveQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SaveQuestionnaireFormQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormSection = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormSection',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.deleteQuestionnaireFormSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormSection',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormSection,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.deleteQuestionnaireFormSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormSection',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormQuestion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormQuestion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.deleteQuestionnaireFormQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormQuestion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.deleteQuestionnaireFormQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DeleteQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteQuestionnaireFormQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_QuestionnaireService_ReorderQuestionnaireFormSections = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ReorderQuestionnaireFormSections',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.reorderQuestionnaireFormSections =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ReorderQuestionnaireFormSections',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ReorderQuestionnaireFormSections,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.reorderQuestionnaireFormSections =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ReorderQuestionnaireFormSections',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ReorderQuestionnaireFormSections);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_QuestionnaireService_MoveQuestionnaireFormQuestion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/MoveQuestionnaireFormQuestion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.moveQuestionnaireFormQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/MoveQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_MoveQuestionnaireFormQuestion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.moveQuestionnaireFormQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/MoveQuestionnaireFormQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_MoveQuestionnaireFormQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.AddVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.AddVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_AddVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.AddVendorQuestionnaireRequest,
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.AddVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.AddVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.addVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AddVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.AddVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.addVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AddVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.updateVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.updateVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersRequest,
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse>}
 */
const methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaireReminders = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaireReminders',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersRequest,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse,
  /**
   * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.updateVendorQuestionnaireReminders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaireReminders',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaireReminders,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.UpdateVendorQuestionnaireRemindersResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.updateVendorQuestionnaireReminders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaireReminders',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaireReminders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireReminderRecipientOptionsRequest,
 *   !proto.common.DueDateReminderRecipientOptions>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaireReminderRecipientOptions = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireReminderRecipientOptions',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnaireReminderRecipientOptionsRequest,
  common_due_date_reminder_pb.DueDateReminderRecipientOptions,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireReminderRecipientOptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_due_date_reminder_pb.DueDateReminderRecipientOptions.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireReminderRecipientOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.common.DueDateReminderRecipientOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.common.DueDateReminderRecipientOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaireReminderRecipientOptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireReminderRecipientOptions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireReminderRecipientOptions,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireReminderRecipientOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.common.DueDateReminderRecipientOptions>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaireReminderRecipientOptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireReminderRecipientOptions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireReminderRecipientOptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest,
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.removeVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.removeVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest,
 *   !proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse>}
 */
const methodDescriptor_QuestionnaireService_SetVendorQuestionnaireStatus = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SetVendorQuestionnaireStatus',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest,
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse,
  /**
   * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.setVendorQuestionnaireStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SetVendorQuestionnaireStatus',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SetVendorQuestionnaireStatus,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.setVendorQuestionnaireStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SetVendorQuestionnaireStatus',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SetVendorQuestionnaireStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SetAnswerJudgmentRequest,
 *   !proto.tprmquestionnaire.SetAnswerJudgmentResponse>}
 */
const methodDescriptor_QuestionnaireService_SetAnswerJudgment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SetAnswerJudgment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SetAnswerJudgmentRequest,
  proto.tprmquestionnaire.SetAnswerJudgmentResponse,
  /**
   * @param {!proto.tprmquestionnaire.SetAnswerJudgmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SetAnswerJudgmentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SetAnswerJudgmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SetAnswerJudgmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SetAnswerJudgmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.setAnswerJudgment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SetAnswerJudgment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SetAnswerJudgment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SetAnswerJudgmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SetAnswerJudgmentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.setAnswerJudgment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SetAnswerJudgment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SetAnswerJudgment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListVendorQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnairesRequest,
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListVendorQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListVendorQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListVendorQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_GetVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetVendorQuestionnaireRequest,
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listReceivedQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listReceivedQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest,
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest,
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaireVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaireVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest,
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaireAttachments = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireAttachments',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest,
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaireAttachments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireAttachments',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireAttachments,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaireAttachments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireAttachments',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireAttachments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest,
 *   !proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse>}
 */
const methodDescriptor_QuestionnaireService_DownloadVendorQuestionnaireAttachment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/DownloadVendorQuestionnaireAttachment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest,
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse,
  /**
   * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.downloadVendorQuestionnaireAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DownloadVendorQuestionnaireAttachment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DownloadVendorQuestionnaireAttachment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.downloadVendorQuestionnaireAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/DownloadVendorQuestionnaireAttachment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DownloadVendorQuestionnaireAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>}
 */
const methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getVendorQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getVendorQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 */
const methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.CreateCommentRequest,
 *   !proto.tprmquestionnaire.Comment>}
 */
const methodDescriptor_QuestionnaireService_CreateComment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/CreateComment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.CreateCommentRequest,
  proto.tprmquestionnaire.Comment,
  /**
   * @param {!proto.tprmquestionnaire.CreateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.Comment.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.Comment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.Comment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.createComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.Comment>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.createComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListCommentThreadRequest,
 *   !proto.tprmquestionnaire.ListCommentThreadResponse>}
 */
const methodDescriptor_QuestionnaireService_ListCommentThread = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListCommentThreadRequest,
  proto.tprmquestionnaire.ListCommentThreadResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListCommentThreadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListCommentThreadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listCommentThread =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListCommentThreadResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listCommentThread =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread);
};


module.exports = proto.tprmquestionnaire;

